import * as React from "react"
import NewsContent from "@components/NewsContent"
import parseContentImages, { ParseContentImagesProps } from "@utils/parseContentImages"
import { NewsContentBackgroundStyle, NewsContentSectionProps } from "@components/NewsContent/types"

const StrapiNewsContent = ({
    background_style: backgroundStyle,
    sections
}: GatsbyTypes.NewsContentFragment) => {
    return <NewsContent
        backgroundStyle={backgroundStyle as NewsContentBackgroundStyle}
        sections={sections?.map((section) => ({
            title: `${section?.title}`,
            content: parseContentImages(
                section?.content,
                section?.content_images as ParseContentImagesProps[]
            )
        } as NewsContentSectionProps))}
    />
}

export default StrapiNewsContent
